import angular from 'angular';

import MobileScrollDirective from './mobile-scroll.directive';

const MobileScrollModule = angular
    .module('control-room.commons.basic.directives.mobile-scroll', [])
    .directive('crMobileScroll', MobileScrollDirective.directiveFactory);

export default MobileScrollModule;
